import { render, staticRenderFns } from "./MultipleTemplateDeleteModal.vue?vue&type=template&id=6d5b2be2"
import script from "./MultipleTemplateDeleteModal.vue?vue&type=script&lang=js"
export * from "./MultipleTemplateDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d5b2be2')) {
      api.createRecord('6d5b2be2', component.options)
    } else {
      api.reload('6d5b2be2', component.options)
    }
    module.hot.accept("./MultipleTemplateDeleteModal.vue?vue&type=template&id=6d5b2be2", function () {
      api.rerender('6d5b2be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/MultipleTemplateDeleteModal.vue"
export default component.exports